import { useState } from "react";

import {
  SchedulerName,
  SchedulerStatusResponse,
  useGetAdminSchedulersQuery,
} from "../../../../services";
import { toSectionState } from "../../utils/sectionState";
import { problemsFirst } from "../../utils/status";
import { SchedulerFilter } from "../types";

const NO_SCHEDULERS: SchedulerStatusResponse[] = [];

export const useSchedulers = () => {
  const query = useGetAdminSchedulersQuery();
  const [filter, setFilter] = useState<SchedulerFilter>("all");
  const [selectedName, setSelectedName] = useState<SchedulerName | null>(null);

  const section = toSectionState(query);
  const schedulers =
    section.state === "available" ? section.data : NO_SCHEDULERS;
  const visibleSchedulers = problemsFirst(
    schedulers.filter(({ status }) => filter === "all" || status === filter),
  );
  const selected =
    visibleSchedulers.find(({ name }) => name === selectedName) ??
    visibleSchedulers[0] ??
    null;

  return {
    section,
    filter,
    setFilter,
    hasSchedulers: schedulers.length > 0,
    visibleSchedulers,
    selected,
    select: setSelectedName,
    isRefreshing: query.isFetching,
    refresh: () => void query.refetch(),
  };
};
